import Form from "JS/form/Form";
import { notice } from "JS/utils/notice";

class FetchSubscribe {
    /**
     * @type {Form}
     */
    form;

    isLoading = false;

    /**
     * Показать всю сакральность лоадера
     */
    loaderDelay = 200;

    /**
     * 
     * @param {HTMLFormElement} form 
     */
    constructor(form) {
        if (!form) {
            return;
        }
        this.form = new Form(form);
        this.modalSuccess = form.querySelector('.final-modal');
        this.submitButton = form.querySelector('.submit-btn');
        this.addListeners();
    }

    addListeners() {
        this.form.on('submit', (data) => {
            if (this.isLoading) {
                return;
            }

            this.fetchData(data);
        });
    }

    
    fetchData(data) {
        this.isLoading = true;

        const formData = new FormData();

        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        formData.append('action', 'subscribe');
        formData.append('nonce', backendData.subscribe_nonce);

        this.submitButton.classList.add('processing');

        fetch(backendData.ajaxUrl, {
            method: "POST",
            body: formData,
        })
        .then((res) => res.json())
        .then((data) => {
            this.isLoading = false;

            if (data.success) {
                this.submitButton.classList.remove('processing');
                notice(data.data?.message, 'success');
            } else {
                this.submitButton.classList.remove('processing');
                notice(data.data?.message, 'error');
            }
        })
        .catch((error) => {
            this.submitButton.classList.remove('processing');
            this.isLoading = false;
            notice(error, 'error');
        });
    }
};
(()=> {
    const forms = Array.from(document.querySelectorAll('[data-form="subscribe"]'));
    forms.forEach(form => {
        new FetchSubscribe(form);
    });
})();
